export { default as Col } from "./col";
